import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4B57E9DF-354F-460D-9551-65C0DB55D788
 * name eject
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eject.svg
 * tags
 */
export const EjectIcon = createSvgIcon(<><path d="M12,5L5.33,15H18.67M5,17H19V19H5V17Z" /></>, 'EjectIcon');
export default EjectIcon